import React from 'react';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import FlagOutlinedIcon from '@mui/icons-material/FlagOutlined';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PhoneInTalkOutlinedIcon from '@mui/icons-material/PhoneInTalkOutlined';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import ScheduleIcon from '@mui/icons-material/Schedule';
import SmsOutlinedIcon from '@mui/icons-material/SmsOutlined';

import { StepType } from './workflowModel';

const ICONS: Record<StepType, typeof MailOutlineIcon> = {
  SEND_EMAIL: MailOutlineIcon,
  SEND_SMS: SmsOutlinedIcon,
  SEND_PUSH: CampaignOutlinedIcon,
  ADD_TAG: AddCircleOutlineIcon,
  REMOVE_TAG: RemoveCircleOutlineIcon,
  CREATE_CALL_TASK: PhoneInTalkOutlinedIcon,
  DELAY: ScheduleIcon,
  END: FlagOutlinedIcon,
};

/** Each step type's icon, the same on the canvas, in the add menu and in the list. */
export const StepIcon = ({ type, fontSize = 20 }: { type: StepType; fontSize?: number }) => {
  const Icon = ICONS[type] ?? FlagOutlinedIcon;
  return <Icon sx={{ fontSize }} />;
};
